export default __webpack_public_path__ + "static/media/np.216a8d2a.svg";